<template>
    <div ref="coreBg" id="chuangCore" >
        <!-- <div :class="{'row overwrite-row':true, 'animated rollIn': !isAnimateChangeLanguageOn, 
                        'animated rollOut': isAnimateChangeLanguageOn}"> -->
            <div :class="{'row overwrite-row':true}">
            <div class="col s12 m12 l5 xl5">
                <div class="core-container-description">
                    <h5>{{ coreTitleLanguages[selectedLanguage] }}</h5>
                    <p>{{ coreDescriptionLanguages[selectedLanguage] }}</p>
                </div>
            </div>
            <div class="col s12 m12 l7 xl7">
                <div class="core-container-illustration">
                    <img :src="selectedCoreImg[selectedLanguage]" alt="">

                </div>
            </div>
        </div>
        <div id="personnelLink">

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                bgCh: require('../assets/images/core-illustration-ch.png'),
                bgeng: require('../assets/images/core-illustration-eng.png'),
                isAnimateChangeLanguageOn: false,
                coreTitleLanguages: ['核心價值', '核心价值', 'CORE VALUE'],
                coreDescriptionLanguages:
                [
                    '快樂工作的氛圍、頂尖的技術科技、創新的思維，事業版圖持續拓展，以研製手遊為主，並在台灣、香港、中國、菲律賓、馬來西亞等地已有公司。正陸續朝向日本、韓國、泰國等東南亞國家市場持續拓展，規畫著未來進軍歐美市場。 期許未來打造原創遊戲品牌，在台灣與海外市場佔有一席之地。',
                    '快乐工作的氛围、顶尖的技术科技、创新的思维，事业版图持续拓展，以研制手游为主，并在台湾、香港、中国、菲律宾、马来西亚等地已有公司。正陆续朝向日本、韩国、泰国等东南亚国家市场持续拓展，规画着未来进军欧美市场。 期许未来打造原创游戏品牌，在台湾与海外市场占有一席之地。', 
                    'Happy working atmosphere, top technology,innovative thinking. We mainly develop online games, and have established companies in several places such as Taiwan, Hong Kong, China, Philippines, Malaysia and so on.We are expanding our market in Japan, South Korea, Thailand and other ASEAN countries. One of our goals in to have a market in Europe and America in the near future.We are looking forward to develop original and unique game brand, and make a name in Taiwan locally and abroad.'
                ],
                selectedCoreImg: [],
                coreImg: [
                    [ 
                        require('../assets/images/core-sim-pc-bg.png'),
                        require('../assets/images/core-trad-pc-bg.png'),
                        require('../assets/images/core-eng-pc-bg.png')
                    ],              
                    [ 
                        require('../assets/images/core-sim-mb-bg.png'),
                        require('../assets/images/core-trad-mb-bg.png'),
                        require('../assets/images/core-eng-mb-bg.png')
                    ] 
                ],
                clientWidth: 0,
                selectedLanguage: 0
            }
        },
        methods: {
            startChangeLangAnimation(){
                let _this = this;
                this.isAnimateChangeLanguageOn = true;
                setTimeout(function() {
                    _this.isAnimateChangeLanguageOn = false;
                }, 1);
            },
            changeIntroBackground(){
                if(this.clientWidth <= 900) {
                    this.$refs.coreBg.style.backgroundImage = "url("+ require('../assets/images/core-bg-mobile.png') + ")";
                } else if (this.clientWidth > 900) {
                    this.$refs.coreBg.style.backgroundImage = "url("+ require('../assets/images/core-bg.png') + ")";
                }
            },
            changeCoreBackground() {
                if(this.clientWidth <= 900) {
                    this.selectedCoreImg = this.coreImg[1] 
                } else if (this.clientWidth > 900) {
                    this.selectedCoreImg = this.coreImg[0] 
                }
            }
        },
        mounted: function() {
            let _this = this;
            this.$root.$on('languageChange', function(e){
                _this.selectedLanguage = parseInt(e);
                _this.changeIntroBackground();
            })
            this.$root.$off('animageChangeLanguage', function(e){
                 _this.startChangeLangAnimation();
            })
            window.addEventListener('resize', function(e){
                let h = document.getElementById('chuangCore').offsetHeight;
                _this.clientWidth = document.getElementById('chuangIntroduction').clientWidth;
                _this.$root.$emit('updateCoreSize', h)
                _this.changeIntroBackground();
                _this.changeCoreBackground();
            });
             window.addEventListener('load', function(e){
                let h = document.getElementById('chuangCore').offsetHeight;
                _this.clientWidth = document.getElementById('chuangIntroduction').clientWidth;
                _this.$root.$emit('updateCoreSize', h)
                _this.changeIntroBackground();
                _this.changeCoreBackground();
            });
        },
    }
</script>

<style lang="less" scoped>
@import url('../assets/css/base.less');

    #personnelLink {
        height: 90px;
        position: absolute;
        bottom: 0;
        @media @1920 {
            height: 5.7rem;
        }
        @media @1600 {
            height: 5.7rem;
        }
        @media @1400 {
            height: 5.7rem;
        }
        @media @1200 {
            height: 5.8rem;
        }
        @media @990 {
            height: 5.5rem;
        }
        @media @768 {
            height: 4.3rem;
        }
        @media @479 {
            height: 4.3rem;
        }
        @media @360 {
            height: 4.3rem;
        }
        @media @320 {
            height: 4.3rem;
        }
    }

    #chuangCore {
        min-width: @min-width;
        padding-top: 7rem;
        padding-bottom: 3rem;
        padding-left: 3rem;
        padding-right: 3rem;
        background: url('../assets/images/core-bg.png') no-repeat center;
        background-size: cover; 
        position: relative;
        @media @479 {
            padding-top: 2rem;
            padding-left: 0;
            padding-right: 0;
        }


    }
    .overwrite-row {
        margin-bottom: none!important;
    }
    
    .core-container-description {
        color: #e5e5e5;
        width: 37rem;
        margin: 0 auto;
        
        @media @1920 {
            width: 37rem;
        }
        @media @1600 {
            width: 35rem;
        }
        @media @1400 {
            width: 30rem;
        }
        @media @1200 {
            width: 25rem;
        }
        @media @990 {
            width: 40rem;
        }
        @media @768 {
            width: 44rem;
        }
        @media @479 {
            width: 19rem;
        }
        @media @360 {
            width: 19rem;
        }
        @media @320 {
            width: 19rem;
        }
   
        h5 {
            font-size: @cons-main-text-size-1920;
            margin-bottom: 3rem;
            text-align: left;
            @media @1920 {
                text-align: left;
                font-size: @cons-main-text-size-1920;
            }
            @media @1600 {
                text-align: left;
                font-size: @cons-main-text-size-1920;
            }
            @media @1400 {
                text-align: left;
                font-size: @cons-main-text-size-1920;
            }
            @media @1200 {
                text-align: left;
                font-size: @cons-main-text-size-1920;
            }
            @media @990 {
                text-align: center;
                font-size: @cons-main-text-size-1920;
            }
            @media @768 {
                text-align: center;
                font-size: @cons-main-text-size-1920;
            }
            @media @479 {
                text-align: center;
                font-size: @cons-main-text-size-1920;
            }
        }
        p {
            font-size: @cons-description-text-size-1920;
            line-height: 36px;
            margin-bottom: 3rem;
            @media @1920 {
                font-size: @cons-description-text-size-1920;
            }
            @media @1600 {
                font-size: @cons-description-text-size-1920;
            }
            @media @1400 {
                font-size: @cons-description-text-size-1920;
            }
            @media @1200 {
                font-size: @cons-description-text-size-1920;
            }
            @media @990 {
                font-size: @cons-description-text-size-1920;
            }
            @media @768 {
                font-size: @cons-description-text-size-1920;
            }
            @media @479 {
                font-size: @cons-description-text-size-1920;
            }
        }
    }
    .core-container-illustration {
        position: relative;
        img {
            width: 100%;
        }
    }
    .tags-container {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
    }
    .tags {
        height: 14%;
        top: 0;
        left: 0;
        color: #e5e5e5;
        font-size: @cons-sub-title-size-1920;
        padding-top: 4%;
        @media @1200 {
            padding-top: 28%;
            font-size: @cons-sub-title-size-1920;
        }
        @media @1920 {
            font-size: @cons-main-text-size-1600;
        }
        @media @1600 {
            font-size: @cons-main-text-size-1600;
        }
        @media @1400 {
            font-size: @cons-main-text-size-1400;
        }
        @media @1200 {
            font-size: @cons-main-text-size-768;
        }
        @media @990 {
            font-size: @cons-main-text-size-1600;
        }
        @media @768 {
            font-size: @cons-main-text-size-479 - 0.2;
        }
        @media @479 {
            font-size: @cons-main-text-size-479 - 0.4;
            padding-top: 0%;
        }
    }
    .tag1 {
        text-indent: 17%;
        @media @479 {
            padding-top: 1.6%;
            text-indent: 17%;
        }
    }
    .tag2 {
        text-indent: 20%;
    }
    .tag3 {
        text-indent: 24%;
        padding-top: 0%;
    }
    .tag4 {
        text-indent: 28%;
    }
    .tag5 {
        text-indent: 31%;
    }
    .ch-core-align {
        @media @479 {
            padding-top: 2%;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/ChuangCore.vue